import React, { useState, useEffect } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';

const UpdateLocation = () => {
  const { id } = useParams(); // Get location ID from URL
  const [location, setLocation] = useState('');
  const [description, setDescription] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [existingImage, setExistingImage] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await api.get(`/locations/${id}`);
        const locationData = response.data;
        setLocation(locationData.location);
        setDescription(locationData.description);
        setExistingImage(locationData.imagePath);
      } catch (error) {
        console.error('Error fetching location:', error);
        alert('Failed to fetch location data');
      }
    };
    fetchLocation();
  }, [id]);

  const validateImageDimensions = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        if (image.width <= maxWidth && image.height <= maxHeight) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      image.onerror = () => {
        reject(new Error('Invalid image file'));
      };
      image.src = URL.createObjectURL(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!location.trim()) errors.location = 'Location cannot be empty';
    const isDescriptionEmpty = description.replace(/<(.|\n)*?>/g, '').trim() === '';
    if (isDescriptionEmpty) errors.description = 'Description cannot be empty';


    const allowedImageTypes = ['image/png', 'image/jpeg'];
    if (imageFile) {
      if (!allowedImageTypes.includes(imageFile.type)) {
        errors.imageFile = 'Only PNG and JPG files are allowed';
      } else {
        const isValidImage = await validateImageDimensions(imageFile, 239, 350);
        if (!isValidImage) {
          errors.imageFile = 'Image must be under 239px by 230px';
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setErrors({});

    const formData = new FormData();
    formData.append('location', location);
    formData.append('description', description);
    if (imageFile) {
      formData.append('image', imageFile);
    }

    try {
      const response = await api.put(`/locations/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        setTimeout(() => {
          alert(`Location updated successfully! ID: ${id}`);
        }, 1000);
        setTimeout(() => {
          navigate('/manage-location');
        }, 1000);
      } else {
        alert('Failed to update location');
      }
    } catch (error) {
      console.error('Error updating location:', error);
      alert('Error updating location');
    }
  };

  const handleCancel = () => {
    navigate('/manage-location');
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag='h5' className='mb-3'>
        Location List <span style={{ color: '#B0B0B0' }}>/ Edit Location</span>
      </CardTitle>
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <div className="col-xl-8">
              <div className='mb-3'>
                <label className='form-label'>Location Name *</label>
                <input type="text" className={`form-control ${errors.location ? 'is-invalid' : ''}`} value={location} onChange={(e) => setLocation(e.target.value)} />
                <b>{errors.location && <span className='text-danger small'>{errors.location}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Description *</label>
                <ReactQuill
                  value={description}
                  onChange={setDescription}
                  className=''
                  placeholder="Enter Description"
                />
                <b>{errors.description && <span className='text-danger small'>{errors.description}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Upload Image (only PNG and JPG size 239px*350px)</label>
                <input type="file" className={`form-control ${errors.imageFile ? 'is-invalid' : ''}`} onChange={(e) => setImageFile(e.target.files[0])} />
                <b>{errors.imageFile && <span className='text-danger small'>{errors.imageFile}</span>}</b>
                <div className='mt-2'>
                  {existingImage && !imageFile && (
                    <img style={{ width: '100px', height: '100px' }} src={`${process.env.REACT_APP_IMAGE_BASE_URL}${existingImage}`} alt="Location" />
                  )}
                </div>
              </div>

              <div className="button-group">
                <button type="submit" className="btn btn-success submit-button">Update</button>
                <button type="button" className="btn btn-danger cancel-button" onClick={handleCancel}>Cancel</button>
              </div>
            </div>
          </form>
        </CardBody>
      </Card>
    </div>
  );
};

export default UpdateLocation;
